import React from 'react'
import { components } from 'react-select'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import { useTranslate } from 'lib/tolgee'

import './index.scss'

const TOLGEE_PREFIX = 'ComparisonSelector-CustomGroupHeadingLabel'

function CustomGroupHeadingLabel(props) {
  const t = useTranslate()

  if (props?.data?.type === 'globalTopic') {
    return (
      <components.GroupHeading {...props}>
        <div className="ComparisonSelector-CustomGroupHeadingLabelWrapper">
          <span>{props.data.label}</span>

          <TooltipWrapper
            tooltipMessage={t({
              key: `${TOLGEE_PREFIX}-tooltipMessage`,
              defaultValue: 'Music topics are global and not separated by languages ​​like other topics.',
            })}
            isTooltipMultiline
            tooltipStyle="tooltippedS"
          >
            <Icon fill="var(--color_primary_500)" height={16} width={16} icon="questionMark" />
          </TooltipWrapper>
        </div>
      </components.GroupHeading>
    )
  }

  return <components.GroupHeading {...props} />
}

export default CustomGroupHeadingLabel
